"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.METER_FIELD_META = void 0;
// Meter fields tracked by the Update vs Correction diff. Used by the edit
// dialog and the history timeline so they show the same set of fields in the
// same order.
var METER_FIELD_META = [
    { key: "serialNumber", label: "Serial Number", group: "Basic" },
    { key: "meterType", label: "Meter Type", group: "Basic" },
    { key: "meterLevel", label: "Meter Level", group: "Basic" },
    { key: "meterMake", label: "Make", group: "Basic" },
    { key: "meterModel", label: "Model", group: "Basic" },
    { key: "meterLocation", label: "Location", group: "Basic" },
    { key: "description", label: "Description", group: "Basic" },
    { key: "isActive", label: "Active", group: "Basic" },
    { key: "buildingName", label: "Building", group: "Linkage" },
    { key: "areaName", label: "Area", group: "Linkage" },
    { key: "tenantName", label: "Tenant", group: "Linkage" },
    { key: "responsibleParty", label: "Responsible Party", group: "Linkage" },
    { key: "kvaRating", label: "kVA Rating", group: "Electrical" },
    { key: "breakerSize", label: "Breaker Size", group: "Electrical" },
    { key: "phaseCount", label: "Phase Count", group: "Electrical" },
    { key: "rateCard", label: "Rate Card", group: "Billing" },
    { key: "multiplier", label: "Multiplier", group: "Billing" },
    { key: "consumptionCategory", label: "Consumption Category", group: "Billing" },
    { key: "isManualReading", label: "Manual Reading", group: "Billing" },
    { key: "effectiveConsumptionDate", label: "Effective Consumption Date", group: "Dates" },
    { key: "installationDate", label: "Installation Date", group: "Dates" },
    { key: "calibrationDate", label: "Calibration Date", group: "Dates" },
    { key: "nextCalibrationDate", label: "Next Calibration Date", group: "Dates" },
    { key: "source", label: "Source", group: "Other" },
    { key: "notes", label: "Notes", group: "Other" },
];
exports.METER_FIELD_META = METER_FIELD_META;
